var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M507.94 457.69C502.38 467.54 491.94 473.63 480.63 473.63L31.37 473.63C20.06 473.63 9.62 467.54 4.06 457.69C-1.51 447.84 -1.34 435.75 4.51 426.07L229.13 53.54C234.81 44.12 245 38.36 256 38.36C266.99 38.36 277.19 44.12 282.86 53.54L507.49 426.07C513.34 435.75 513.51 447.84 507.94 457.69ZM232.02 187.41C232.02 226.77 236.65 283.33 236.65 322.7C236.65 332.95 245.58 337.25 256.17 337.25C264.11 337.25 275.35 332.95 275.35 322.7C275.35 283.33 279.98 226.77 279.98 187.41C279.98 174.5 269.07 167.23 256.17 167.23C242.6 167.23 232.02 174.5 232.02 187.41ZM281.64 385.55C281.64 371.65 270.06 360.08 256.5 360.08C241.94 360.08 231.03 371.65 231.03 385.55C231.03 399.11 241.94 411.02 256.5 411.02C270.06 411.02 281.64 399.11 281.64 385.55Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.524027998ea55a3e96ad6e1e60ec3189.svg";
export { ForwardRef as ReactComponent };